import React, { ReactElement } from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import { AppButton } from "../Generic/AppButton";
import { AppOverlay } from "../Generic/AppOverlay";

interface Props {
  isOpen: boolean;
  onClick: (supportType: number) => void;
  onRequestClose: () => void;
  SupportOptions: SupportOptions;
}

export enum ChatTypeClicked {
  CLINICAL = 0,
  TECHNICAL = 1,
  GENERAL = 2,
}

export enum SupportOptions {
  TRAINING,
  ONBOARDING,
}

export function RequestAssistanceChatBottomSheet(props: Props): ReactElement {
  const handleClick = () =>
    props.onClick(
      props.SupportOptions === SupportOptions.TRAINING
        ? ChatTypeClicked.CLINICAL
        : ChatTypeClicked.GENERAL
    );

  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
        rounded={true}
        title={translate(STRINGS.HOW_CAN_WE_HELP_YOU)}
        className="RequestAssistanceChatBottomSheet"
      >
        <AppButton variant="outline" color="white" onClick={handleClick}>
          {translate(
            props.SupportOptions === SupportOptions.TRAINING
              ? STRINGS.CLINICAL_SUPPORT
              : STRINGS.GENERAL_SUPPORT
          )}
        </AppButton>
        <AppButton
          variant="outline"
          color="white"
          onClick={() => props.onClick(ChatTypeClicked.TECHNICAL)}
        >
          {translate(STRINGS.TECHNICAL_SUPPORT)}
        </AppButton>
      </AppBottomSheet>
    </AppOverlay>
  );
}
